import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import { Icon } from '@iconify/react';
import Spacing from '../Spacing';
import Post from '../Post';
// import Sidebar from '../Sidebar';
// import AuthorWidget from '../Widget/AuthorWidget';
// import CommentsWidget from '../Widget/CommentsWidget';
// import ReplyWidget from '../Widget/ReplyWidget';
import { pageTitle } from '../../helpers/PageTitle';
import { COMPANY_WHATSAPP } from '../../constants/brand';
// const tags = [
//   { tag: 'Emergency', href: '/blog/blog-details' },
//   { tag: 'Pediatric', href: '/blog/blog-details' },
//   { tag: 'Cardiology', href: '/blog/blog-details' },
//   { tag: 'Psychiatry', href: '/blog/blog-details' },
//   { tag: 'Others', href: '/blog/blog-details' },
// ];
const relatedBlog = [
  {
    id: 'kerala-the-ultimate-destination-for-world-class-medical-tourism',
    title: 'Kerala: The Ultimate Destination for World-Class Medical Tourism',
    thumbUrl: "/images/blog/1.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/kerala-the-ultimate-destination-for-world-class-medical-tourism',
    socialShare: false,
  },
  {
    id: 'ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness',
    title: 'Ayurveda & Holistic Healing: Why Tourists Choose Kerala for Wellness',
    thumbUrl: "/images/blog/2.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness',
    socialShare: false,
  },
  {
    id: 'a-complete-guide-to-medical-travel-in-kerala-what-to-expect',
    title: 'A Complete Guide to Medical Travel in Kerala: What to Expect',
    thumbUrl: "/images/blog/3.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/a-complete-guide-to-medical-travel-in-kerala-what-to-expect',
    socialShare: false,
  },
];

const blogDetails = {
  'kerala-the-ultimate-destination-for-world-class-medical-tourism': {
    title: 'Kerala: The Ultimate Destination for World-Class Medical Tourism',
    thumbUrl: "/images/blog/1.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/kerala-the-ultimate-destination-for-world-class-medical-tourism',
    socialShare: false,
    author: 'Nihal Ansar',
    content: `<h2>Why Choose Kerala for Medical Tourism?</h2>
<p>
  Kerala is emerging as a global hub for medical tourism, offering advanced healthcare at affordable prices. The state is renowned for its combination of modern medical facilities and traditional healing practices, making it a preferred destination for international patients.
  <br /><br />
  Key reasons why Kerala stands out in medical tourism:
</p>
<ol>
  <li>
    <b>World-Class Healthcare Facilities:</b>  
    <br />
    Kerala has internationally accredited hospitals with state-of-the-art technology and top medical professionals.
  </li>
  <li>
    <b>Affordable Treatment Costs:</b>  
    <br />
    Medical procedures in Kerala cost significantly less compared to Western countries, without compromising quality.
  </li>
  <li>
    <b>Comprehensive Treatment Options:</b>  
    <br />
    Patients can access specialized care in cardiology, oncology, orthopedics, neurology, and more.
  </li>
  <li>
    <b>Seamless Medical Travel Assistance:</b>  
    <br />
    Services like medical visa support, airport transfers, and accommodation make the journey hassle-free.
  </li>
  <li>
    <b>Ayurveda and Holistic Healing:</b>  
    <br />
    Kerala is the birthplace of Ayurveda, offering wellness therapies that complement modern treatments.
  </li>
  <li>
    <b>Scenic Recovery Destinations:</b>  
    <br />
    Patients can recuperate in peaceful environments like Kerala’s backwaters, beaches, and hill stations.
  </li>
</ol>`
  },
  'ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness':
  {
    title: 'Ayurveda & Holistic Healing: Why Tourists Choose Kerala for Wellness',
    thumbUrl: "/images/blog/2.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness',
    socialShare: false,
    author: 'Nihal Ansar',
    content: `<h2>The Power of Ayurveda in Kerala</h2>
<p>
  Ayurveda, the 5,000-year-old system of natural healing, is deeply rooted in Kerala’s culture. It focuses on balancing the mind, body, and spirit through personalized therapies.
  <br /><br />
  Here are some of the most sought-after Ayurvedic treatments in Kerala:
</p>
<ol>
  <li>
    <b>Panchakarma Therapy:</b>  
    <br />
    A deep detoxification process that purifies the body, improves immunity, and restores balance.
  </li>
  <li>
    <b>Abhyanga (Ayurvedic Oil Massage):</b>  
    <br />
    A full-body massage using herbal oils that nourish the skin, improve circulation, and relieve stress.
  </li>
  <li>
    <b>Shirodhara (Mental Wellness Therapy):</b>  
    <br />
    A soothing therapy where warm herbal oil is poured on the forehead to calm the nervous system.
  </li>
  <li>
    <b>Udwarthanam (Weight Loss Therapy):</b>  
    <br />
    A special herbal scrub therapy that enhances metabolism and aids in weight reduction.
  </li>
  <li>
    <b>Nasya (Sinus & Respiratory Treatment):</b>  
    <br />
    A therapy that involves herbal nasal drops to cleanse and strengthen the respiratory system.
  </li>
  <li>
    <b>Ayurvedic Diet & Lifestyle Consultation:</b>  
    <br />
    Personalized wellness plans based on Ayurvedic principles to maintain long-term health.
  </li>
</ol>`
  },
  'a-complete-guide-to-medical-travel-in-kerala-what-to-expect':
  {
    title: 'A Complete Guide to Medical Travel in Kerala: What to Expect',
    thumbUrl: "/images/blog/3.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/a-complete-guide-to-medical-travel-in-kerala-what-to-expect',
    socialShare: false,
    author: 'Nihal Ansar',
    content: `<h2>Planning Your Medical Travel to Kerala</h2>
<p>
  Medical tourism in Kerala is a seamless experience when planned well. From initial consultation to post-treatment care, here’s a step-by-step guide to ensure a smooth journey.
  <br /><br />
  Key steps in planning your medical trip:
</p>
<ol>
  <li>
    <b>Step 1: Choose the Right Medical Treatment</b>  
    <br />
    Consult with experts online to assess your medical condition and receive recommendations on the best treatment options.
  </li>
  <li>
    <b>Step 2: Secure a Medical Visa</b>  
    <br />
    Apply for a medical visa with the necessary documents, including hospital invitations and treatment plans.
  </li>
  <li>
    <b>Step 3: Arrange Accommodation & Travel</b>  
    <br />
    Choose from budget-friendly stays to luxury wellness resorts, with local transport services for convenience.
  </li>
  <li>
    <b>Step 4: Undergo Treatment & Recovery</b>  
    <br />
    Experience high-quality healthcare with personalized attention from top doctors and specialists.
  </li>
  <li>
    <b>Step 5: Post-Treatment Care & Wellness</b>  
    <br />
    Get continuous follow-up consultations and consider Ayurvedic therapies for holistic healing.
  </li>
  <li>
    <b>Step 6: Explore Kerala During Recovery</b>  
    <br />
    Visit Kerala’s scenic backwaters, hill stations, and cultural sites for a rejuvenating recovery experience.
  </li>
</ol>`
  },
}

const sharePage = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: document.title, // Use page title
        text: 'Check out this amazing blog!', // Custom text
        url: window.location.href, // Current page URL
      });
      console.log('Shared successfully!');
    } catch (error) {
      console.error('Error sharing:', error);
    }
  } else {
    alert('Native sharing is not supported in your browser.');
  }
};

export default function BlogDetails() {
  const { blogId } = useParams(); // Get blogId from URL params
  pageTitle(`Blog Details - ${blogDetails[blogId].title}`);
  return (
    <>
      <Section topMd={170} bottomMd={20} bottomLg={20} topSm={100} bottomSm={20}>
        <Breadcrumb title={blogDetails[blogId].title} />
      </Section>
      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            {/* <div className="cs_blog_details_tags">
              {tags.map((item, index) => (
                <Link key={index} to={item.href}>
                  {item.tag}
                </Link>
              ))}
            </div> */}
            <div className="cs_blog_details_date">
            {blogDetails[blogId].date} | {blogDetails[blogId].author}
            </div>
          </div>
          <div className="cs_social_links_wrap">
            <h2>Share:</h2>
            <div className="cs_social_links">
              <Link onClick={sharePage}>
                <Icon icon="fa-solid:share-alt" />
              </Link>
              {/* <Link to="/">
                <Icon icon="fa-brands:linkedin-in" />
              </Link>
              <Link to="/">
                <Icon icon="fa-brands:twitter" />
              </Link> */}
            </div>
          </div>
        </div>
        <Spacing md="55" />
        <img
          src={blogDetails[blogId].thumbUrl}
          alt="Blog Details"
          className="w-100 cs_radius_20"
        />
        <Spacing md="90" lg="50" />
        <div className="row">
          <div className="col-lg-8">
            <div className="cs_blog_details" dangerouslySetInnerHTML={{ __html: blogDetails[blogId].content }}></div>
            {/* <Spacing md="85" />
            <AuthorWidget
              imgUrl="/images/blog/author.png"
              name="Author Bio"
              description="John Smith is a freelance writer and content strategist with a passion for helping businesses tell their stories. With over 10 years of experience in the industry, John has worked with a wide range of clients, from startups to Fortune 500 companies. He holds a Bachelor's degree in English from the University of California, Los Angeles (UCLA), and is an avid reader and traveler in his free time. Follow him on Twitter @johnsmithwriter for the latest updates on his work."
            />
            <Spacing md="110" />
            <CommentsWidget title="Comments" />
            <Spacing md="92" />
            <ReplyWidget title="Leave a Reply" /> */}
          </div>
          {/* <div className="col-lg-4">
            <Sidebar />
          </div> */}
        </div>
        <Spacing md="57" lg="57" sm='50' />
        <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
        <Spacing md="57" sm='40' />
        <div className="row cs_gap_y_40">
        {relatedBlog
          .filter(item => item.id !== blogId) // Filter out the current blog
          .map((item, index) => (
            <div className="col-xl-4 col-md-6" key={index}>
              <Post {...item} />
            </div>
          ))}
        </div>
      </div>
      {/* <Spacing md="70" xl="70" lg="70" sm='70' /> */}
      <Section className="cs_footer_margin_0" topMd={20} topSm={70}>
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/consult.png"
          btnText="Chat With Us"
          btnUrl={COMPANY_WHATSAPP}
        />
      </Section>
    </>
  );
}
